import { EnvironmentType } from "@env/EnvironmentType";

export const environment: EnvironmentType = {
  production: false,
  testSystem: false,
  apiHostname: "api",
  wsHostname: "wss://turnportal-qa.digiturndev.net/ws",
};
